import {useContext} from 'react';
import {AdminStoreContext} from 'stores/contexts/AdminStore';

export const useAdminStore = () => useContext(AdminStoreContext);
